import {MIN_TRAINING_PHOTOS} from '@core/hooks/useModelIntake'

/**
 * Templated copy rendered at the bottom of every pack landing page.
 * One source of truth — do NOT edit per-pack.
 */
export const ABOUT_NARCIS = {
    title: 'About narcis',
    paragraph:
        'Most AI photo tools put every pose, job, era, and style in one giant catalog. The photos ' +
        'all look like every other AI photo on the internet — a glaze over a stock face. Narcis goes ' +
        'the other way. One job: photos of you that look like photographs. You add at least ' +
        `${MIN_TRAINING_PHOTOS} photos of yourself, and we create your AI model from them. Your photos are ` +
        'ready in a few hours, and we email you when they are. Then this pack and every other pack on ' +
        'Narcis can be made with your face. Each pack is curated against real references — paintings, ' +
        'photographers, places — and tested on real faces before it goes live. Built and run by one ' +
        'small team, on our own servers.',
} as const
